<template>
    <div>
        <vueHeader :navNum="1"></vueHeader>

        <div class="banner">
            <img src="./../assets/img/medical/banner.jpg" alt="">
        </div>

        <div class="about wrap">
            <div class="left"></div>
            <div class="right">
                <p class="title">关于医疗</p>
                <div class="top">
                    <p class="txt">自一九九九年起我们一直在医疗领域，是浙江省内最早涉及到科学地应对术中气道管理和血液动力学的专业公司之一。至今，我们在气道管理和血液动力学这两个专业领域已经积累了丰富的经验和产品。
                    </p>
                    <p class="txt">我们拥有的先进医疗医疗器械。</p>
                </div>
                <div class="bottom">
                    <p class="txt">我们深知医学在不断进步与更新，我们也持续积累医学经验，引进多品类产品，不断更新公司产品，增加公司产品市场竞争优势，稳定立足医疗领域。</p>
                    <p class="txt">在2003年，我们与所有人一起经历了令人心悸的“非典”时期，2020年，我们将与所有人一起努力渡过“冠状病毒”时期。虽然疾病凶险，过程艰难，但我们一直都竭尽全力，带给用户的不止先进的医疗仪器、治疗方法，更是爱与希望。</p>
                </div>
            </div>
        </div>

        <div class="product">
            <div class="left">
                <p class="headline">我们拥有哪些<br />先进的医疗器械产品？</p>
                <p class="txt">我们也是浙江乃至全国最早提出家庭健康护理中心（Homecare）的公司之一，除了一直致力于更好的帮助睡眠呼吸障碍的病人之外，我们更试图在大健康和抗衰老这两个领域尽我们最大的努力和耕耘。我们深知，没有用户的认可，我们不可能一直走到今天。未来的日子，我们将一如继往，把先进的治疗理念和治疗方法带给我们的用户，把更多的研发技术和研发成果回报给我们的用户和社会。</p>
                <router-link to="/product">
                    <div class="more">了解更多</div>
                </router-link>
            </div>
            <ul class="right">
                <li v-for="(item,index) in product" :key="index" @click="goProduct(item.id,item.listId)">
                    <span class="wow fadeInRight" v-html="item.name" data-wow-duration="0.8s" :data-wow-delay="index/3*0.15+'s'"></span>
                </li>
            </ul>
        </div>

        <div class="news">
            <div class="title">
                新闻资讯
                <router-link to="/medicalList">
                    <div class="more">more</div>
                </router-link>
            </div>
            <swiper class="swiper" :options="swiperOption" ref="mySwiper" v-if="news.length">
                <!-- slides -->
                <swiper-slide v-for="(item,index) in news.slice(0,9)" :key="index">
                    <div class="item" @click="goArtical(item.id)">
                        <div class="news_img"><img :src="item.cover" /></div>
                        <div class="bottom">
                            <div class="left">
                                <p class="title">{{item.title}}</p>
                                <p class="txt">{{item.desc.substring(0,35)}}...</p>
                            </div>
                            <div class="right">
                                <p class="day">{{item.month.substring(5,7)}}-{{item.day}}</p>
                                <p class="year">{{item.month.substring(0,4)}}</p>
                                <div class="go"><img src="./../assets/img/medical/arrow.png" /></div>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <!-- Optional controls -->
                <div class="point" slot="pagination"></div>
            </swiper>
        </div>

        <div class="criterion">
            <div class="criterion-title">LotoHof行为准则</div>
            <ul class="criterion-list">
                <li v-for="(item,index) in criterion" :key="index">
                    <img :src="item.img" alt="">
                    <p class="name">{{item.name}}</p>
                    <p class="desc" v-html="item.desc"></p>
                </li>
            </ul>
        </div>

        <vueFooter></vueFooter>
    </div>
</template>

<script>
import vueHeader from '@/components/header'
import vueFooter from '@/components/footer'
export default {
    data() {
        return {
            product: [
                {
                    id: 0,
                    listId: 0,
                    name: '气管插管（带套囊）',
                },
                {
                    id: 0,
                    listId: 1,
                    name: '气管插管（不带套囊）',
                },
                {
                    id: 1,
                    listId: 0,
                    name: '双腔支气管插管（左侧）',
                },
                {
                    id: 1,
                    listId: 1,
                    name: '双腔支气管插管（右侧）',
                },
                {
                    id: 1,
                    listId: 2,
                    name: '加强型气管插管',
                },
                {
                    id: 3,
                    listId: 0,
                    name: '气管切开套管',
                },
                {
                    id: 3,
                    listId: 1,
                    name: '气管切开插管',
                },
                {
                    id: 4,
                    listId: 0,
                    name: '一次性湿热交换器/过滤器',
                },
                {
                    id: 4,
                    listId: 1,
                    name: '麻醉面罩',
                },
                {
                    id: 4,
                    listId: 2,
                    name: '气管插管管芯针',
                },
                {
                    id: 4,
                    listId: 3,
                    name: '手持压力表',
                },
                {
                    id: 5,
                    listId: 0,
                    name: 'Aquarius连续性血液净化设备',
                },
                {
                    id: 6,
                    listId: 0,
                    name: 'Aqualine管路',
                },
                {
                    id: 6,
                    listId: 1,
                    name: 'HF1200滤器',
                },
                {
                    id: 7,
                    listId: 0,
                    name: 'SCD Express',
                },
                {
                    id: 7,
                    listId: 1,
                    name: 'SCD 700',
                },
                {
                    id: 8,
                    listId: 0,
                    name: '喉镜系列',
                },
                {
                    id: 9,
                    listId: 0,
                    name: '双旋接口延长管<br />（331/5390）',
                },
                {
                    id: 9,
                    listId: 1,
                    name: '双旋接口延长管<br />（331/5661）',
                },
                {
                    id: 9,
                    listId: 2,
                    name: '成人呼吸回路<br />（304/6085）',
                },
                {
                    id: 9,
                    listId: 3,
                    name: '成人麻醉回路<br />（300/6042）',
                },
            ],
            news: [],
            criterion: [
                {
                    img: require('./../assets/img/index/gy_icon_pp.png'),
                    name: '品牌',
                    desc: '同类医疗器械产品中拥有最好用户口碑的产品品牌'
                },
                {
                    img: require('./../assets/img/index/gy_icon_jz.png'),
                    name: '价值',
                    desc: 'LOTO将我们凝聚成一个整体，我们遵循“承诺 信任 责任 声誉”的价值观'
                },
                {
                    img: require('./../assets/img/index/gy_icon_yj.png'),
                    name: '愿景',
                    desc: '我们有责为我们的合作伙伴、患者和医学同仁提供最杰出的方案，并坚守诚信和最高道德标准'
                },
                {
                    img: require('./../assets/img/index/gy_icon_sm.png'),
                    name: '使命',
                    desc: '尽我们最大的努力，把先进的治疗理念和领先的治疗手段带给我们的用户'
                }
            ],
            swiperOption: {
                notNextTick: true,
                slidesPerView: 3,
                spaceBetween: 0,
                slidesPerGroup: 3,
                loop: true, //循环
                initialSlide: 0, //设定初始化时slide的索引
                //autoplay: false, //自动播放
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                speed: 1200, //滑动速度
                direction: "horizontal", //滑动方向
                // grabCursor : true, //小手掌抓取滑动
                on: {
                },
                pagination: {
                    //分页器设置
                    el: ".point",
                    clickable: true
                }
            },
        }
    },

    mounted() {
        window.scrollTo(0, 0);
        new WOW().init();
        this.news = this.$store.state.medicalArtical;
    },

    methods: {
        goArtical(id) {
            this.$store.commit('changemedicalArticalId', id);
            this.$router.push({ path: '/medicalContent' });
        },
        goProduct(productid, listid) {
            this.$store.commit('changeId', productid);
            this.$store.commit('changeListId', listid);
            this.$router.push({ path: '/productDetails' });
        }
    },

    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        }
    },

    components: {
        vueHeader,
        vueFooter
    },
}

</script>

<style scoped lang='less'>
@import "./../assets/css/medical.less";
</style>


// WEBPACK FOOTER //
// src/views/medical.vue